module.exports = __webpack_public_path__ + "img/ae.980f97aa.svg";